export default "__VITE_ASSET__D5M8oKfR__"